import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useSchedule } from '../../hooks/useSchedule';
import { formatWeekRangeFr, getYearFromDate } from '../../utils/helpers';

export function WeekControls({ className }) {
  const { isAuthenticated, hasRole } = useAuth();
  const {
    weeks,
    currentWeek,
    setCurrentWeek,
    exportGrid,
    createWeek,
    loading: scheduleLoading,
  } = useSchedule();

  const handleExport = async () => {
    try {
      await exportGrid();
    } catch (err) {
      console.error('Export failed:', err);
    }
  };

  const handleNewWeek = async () => {
    try {
      await createWeek();
    } catch (err) {
      console.error('Create week failed:', err);
    }
  };

  const weeksByYear = useMemo(() => {
    const groups = {};
    weeks.forEach((w) => {
      const year = getYearFromDate(w.start_date) || 'Autre';
      if (!groups[year]) groups[year] = [];
      groups[year].push(w);
    });
    return Object.entries(groups).sort(([a], [b]) => b.localeCompare(a));
  }, [weeks]);

  return (
    <div className={className}>
      <div className="header-week-selector">
        <label htmlFor="week-select" className="header-week-label">
          Semaine
        </label>
        <select
          id="week-select"
          value={currentWeek?.id ?? ''}
          onChange={(e) => {
            const week = weeks.find((w) => w.id === parseInt(e.target.value, 10));
            setCurrentWeek(week || null);
          }}
          disabled={scheduleLoading || weeks.length === 0}
        >
          {weeks.length === 0 && (
            <option value="">Aucune semaine</option>
          )}
          {weeksByYear.map(([year, yearWeeks]) => (
            <optgroup key={year} label={year}>
              {yearWeeks.map((week) => (
                <option key={week.id} value={week.id}>
                  {formatWeekRangeFr(week.start_date)}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>
      {isAuthenticated && hasRole('admin') && (
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleNewWeek}
          disabled={scheduleLoading}
        >
          + Nouvelle semaine
        </button>
      )}
      <button
        type="button"
        className="btn btn-secondary"
        onClick={handleExport}
        disabled={!currentWeek || scheduleLoading}
      >
        Exporter JSON
      </button>
    </div>
  );
}

export function Header() {
  const { user, logout, isAuthenticated } = useAuth();
  const location = useLocation();
  const isGrillePage = location.pathname === '/';

  return (
    <header className="app-header">
      <div className="header-left">
        {isGrillePage && (
          <WeekControls className="header-schedule-controls" />
        )}
      </div>
      <div className="header-right">
        {isAuthenticated ? (
          <div className="header-user">
            <span className="header-username">{user?.username}</span>
            <button type="button" className="btn btn-secondary" onClick={logout}>
              Déconnexion
            </button>
          </div>
        ) : (
          <Link to="/login" className="btn btn-primary">
            Connexion
          </Link>
        )}
      </div>
    </header>
  );
}
